// extracted by mini-css-extract-plugin
export default {"viewWrapper":"index_viewWrapper__ihBSo","content":"index_content__oTq3e","contentTop":"index_contentTop__Xj5l-"};